import React, { useEffect, useState } from 'react';
import ApexCharts from 'apexcharts';
import api from 'api';

const StatisticsMonthly = () => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // 월별 매출 데이터 조회
  const fetchMonthlySales = async (selectedYear) => {
    setLoading(true);
    try {
      const response = await api.get(`/statistics/monthly?year=${selectedYear}`);
      setData(response);
    } catch (error) {
      console.error('월별 매출 조회 실패:', error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMonthlySales(year);
  }, [year]);

  useEffect(() => {
    // ApexCharts 초기화
    if (data.length === 0) return;

    const options = {
      series: [
        {
          name: '판매액',
          data: data.map(d => Math.floor(d.sales / 100000)), // 단위: 만원
        },
        {
          name: '판매량',
          data: data.map(d => d.quantity),
        },
      ],
      chart: {
        type: 'area',
        height: 350,
        toolbar: {
          show: true,
        },
      },
      colors: ['#4154f1', '#2eca6a'],
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.3,
          opacityTo: 0.4,
          stops: [0, 90, 100],
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
        width: 2,
      },
      xaxis: {
        categories: data.map(d => d.month),
      },
      yaxis: [
        {
          title: {
            text: '판매액 (만원)',
          },
        },
        {
          opposite: true,
          title: {
            text: '판매량',
          },
        },
      ],
      tooltip: {
        shared: true,
        intersect: false,
      },
    };

    const chart = new ApexCharts(document.querySelector('#monthlyChart'), options);
    chart.render();

    return () => {
      chart.destroy();
    };
  }, [data]);

  const handleYearChange = (e) => {
    const selectedYear = parseInt(e.target.value);
    setYear(selectedYear);
    fetchMonthlySales(selectedYear);
  };

  return (
    <div className="row">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">월별 매출 현황</h5>

          <div className="row mb-3">
            <div className="col-sm-3">
              <label htmlFor="yearSelect" className="form-label">
                연도 선택:
              </label>
              <select
                id="yearSelect"
                className="form-control"
                value={year}
                onChange={handleYearChange}
              >
                {[2022, 2023, 2024, 2025, 2026].map((y) => (
                  <option key={y} value={y}>
                    {y}년
                  </option>
                ))}
              </select>
            </div>
            <div className="col-sm-9">&nbsp;</div>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">로딩 중...</span>
              </div>
            </div>
          ) : (
            <div id="monthlyChart"></div>
          )}

          <table className="table table-striped mt-4">
            <thead>
              <tr>
                <th scope="col">월</th>
                <th scope="col">판매액</th>
                <th scope="col">판매량</th>
                <th scope="col">판매건수</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={index}>
                  <td>{item.month}</td>
                  <td>¥{item.sales.toLocaleString('ko-KR')}</td>
                  <td>{item.quantity}</td>
                  <td>{item.customers}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default StatisticsMonthly;
